
import { Table } from 'react-bootstrap';

import { renderTableHeader } from 'components/PaginationContainer';

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSortableTable } from 'hooks/useSortableTable';
import useStickyHeader from 'hooks/useStickyHeader';

import { defaultColumns } from "../../useConst";

import { size, isNil, cloneDeep } from "lodash";
import { filterData, SearchType } from "filter-data";

const columns = defaultColumns(true);

const defaultSearchFields = [
  'licenseTypeLabelFull',
  'licenseStateLabelFull',
  'licenseKey',
  'termUnitLabelFull',
  'deviceTypeLabelFull',
  'releasedAtFormat',
  'deviceUid',
  'deviceModelName',
  'macAddress',
  'startDateFormat',
  'endDateFormat',
  'remainDayUnitLabelFull',
];

const LicensesTableORG = ({
  dataList,
  pagination,
  search,
  setPagination
}) => {
  const { t } = useTranslation();

  const { tableRef, stickyStyle } = useStickyHeader();
  const [tableData, handleSorting] = useSortableTable(dataList, columns);
  const [sortField, setSortField] = useState('');
  const [order, setOrder] = useState('asc');
  const [currentTableData, setCurrentTableData] = useState([]);

  useEffect(() => {
    const newList = filterList();
    setCurrentTableData(newList);
    const newPagination = cloneDeep(pagination);
    newPagination.currentLength = newList.length;
    if (pagination.current > Math.ceil(newList.length / pagination.pageLimit)) {
      newPagination.current = 1;
    }
    setPagination(newPagination);
  }, [search, tableData]);

  const filterList = () => {
    if (isNil(search.type)) {
      return tableData;
    }
    if (search?.type === 'fuzzy') {
      const searchConditions = [{
        key: defaultSearchFields,
        value: search?.searchKey,
        type: SearchType.LK
      }];
      return filterData(tableData, searchConditions);
    } else {
      const searchConditions = [];
      for (const [key, item] of Object.entries(search.searchFields)) {
        if (item.value !== null || size(item.value) > 0) {
          searchConditions.push({
            key,
            value: item.value,
            type: item.searchType,
          });
        }
      }
      return filterData(tableData, searchConditions);
    }
  };

  return (
    <Table responsive striped className="table-container" ref={tableRef}>
      <thead style={stickyStyle}>
        <tr>
          <th>#</th>
          {renderTableHeader(columns, order, setOrder, sortField, setSortField, handleSorting)}
        </tr>
      </thead>
      <tbody>
        {currentTableData?.length > 0 ?
          (currentTableData.slice(
            (pagination.current - 1) * pagination.pageLimit,
            (pagination.current - 1) * pagination.pageLimit + pagination.pageLimit
          ).map((item, index) => {
            return (
              <tr key={index}>
                <td>{(pagination.current - 1) * pagination.pageLimit + index + 1}</td>
                <td>{item.licenseTypeLabelFull}</td>
                <td>{item.licenseStateLabelFull}</td>
                <td>{item.licenseKey}</td>
                <td>{item.termUnitLabelFull}</td>
                <td>{item.deviceTypeLabelFull}</td>
                <td>{item.releasedAtFormat}</td>
                <td>{item.deviceUid}</td>
                <td>{item.deviceModelName}</td>
                <td>{item.macAddress}</td>
                <td>{item.startDateFormat}</td>
                <td>{item.endDateFormat}</td>
                <td>{item.remainDayUnitLabelFull}</td>
              </tr>
            );
          }))
          : (<tr>
            <td colSpan="13" style={{ textAlign: 'center', height: 35 }}>
              {t('ad01242a61')}
            </td>
          </tr>
          )
        }
      </tbody>
    </Table>
  );
};

export default LicensesTableORG;